import AnimationClip from '../AnimationClip';
import Rope from 'Prototype/Rope';
import RopeComponent from 'Component/Render/Rope';

interface IRopeGravityMeta {
}

export class RopeGravity extends AnimationClip<IRopeGravityMeta> {
    public *execute(
        rope: Rope,
        meta: IRopeGravityMeta
    ): IterableIterator<number> {
        const ropeComponent = rope.getComponent(RopeComponent);

        while (true) {
            ropeComponent.updatePhysics();
            yield;
        }
    }
}
